import { Alert, Link as MuiLink, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "i18n-fe";
import { useMissingJudgeSignatures } from "../hooks/useMissingJudgeSignatures";
import StationExceptionLine from "./StationExceptionLine";

// #3454 -- "No signature on file: Cindy Canace (CL 104, CL 106). Add it in
// Judge Manager." A missing judge signature is the show secretary's job, not
// the scribe's, so Score Admin says it (the scribe-side banner is removed by
// #3437). Advisory only, like the scribe one was: it gates nothing. Renders
// nothing when every seated judge on a live, non-paper class has a signature.
export default function MissingSignatureBanner({ showId, compact = false }) {
  const { t } = useTranslation("scoreadmin");
  const missing = useMissingJudgeSignatures(showId);
  if (missing.length === 0) return null;
  if (compact) {
    const names = missing
      .map((m) => {
        const classes = m.classes.map((c) => t("stationMonitor.missingSignature.classLabel", { label: c.label })).join(", ");
        return `${m.judgeName} (${classes})`;
      })
      .join(", ");
    return (
      <StationExceptionLine
        severity="warning"
        testId="missing-signature-banner"
        text={t("stationMonitor.missingSignature.compact", { names })}
        extraLink={{ to: "/judges", label: t("stationMonitor.missingSignature.link"), testId: "missing-signature-link" }}
      />
    );
  }

  return (
    <Alert severity="warning" variant="outlined" data-testid="missing-signature-banner" sx={{ mb: 2 }}>
      {missing.map((m) => (
        <Typography key={m.judgeId} variant="body2" data-testid={`missing-signature-${m.judgeId}`}>
          {t("stationMonitor.missingSignature.line", {
            name: m.judgeName,
            classes: m.classes.map((c) => t("stationMonitor.missingSignature.classLabel", { label: c.label })).join(", "),
          })}
        </Typography>
      ))}
      <MuiLink component={RouterLink} to="/judges" variant="body2" data-testid="missing-signature-link">
        {t("stationMonitor.missingSignature.link")}
      </MuiLink>
    </Alert>
  );
}
